import script from "./CheckpointComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckpointComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CheckpointComponent.vue?vue&type=style&index=0&id=3518617c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3518617c"]])

export default __exports__